import type { ReactNode } from 'react'

const BASE = 'https://drawsword.cdn.modulify.website/images/south-africa'

const PHOTOS = {
    'table-mountain': `${BASE}/table-mountain.jpg`,
    'bo-kaap': `${BASE}/bo-kaap.jpg`,
    'drakensberg': `${BASE}/drakensberg.jpg`,
    'blyde': `${BASE}/blyde-canyon.jpg`
}

type Photo = keyof typeof PHOTOS

const ORDER = Object.keys(PHOTOS) as Array<Photo>

interface SaSlidesProps {
    /** The photo this section starts on. The other three follow in turn. */
    start: Photo
}

/** Slowly crossfading South Africa photos behind a `.sa-photo` section, under its see-through colour tint. */
export const SaSlides = ({ start }: SaSlidesProps): ReactNode => {
    const first = ORDER.indexOf(start)
    const photos = ORDER.map((_, index) => PHOTOS[ORDER[(first + index) % ORDER.length]])

    return (
        <span aria-hidden='true' className='sa-slides'>
            {photos.map(photo => <span key={photo} className='sa-slide' style={{ backgroundImage: `url('${photo}')` }} />)}
            <span className='sa-tint' />
        </span>
    )
}
